var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeIntelligence403Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 281.621,
    height: 281.621,
    viewBox: "0 0 281.621 281.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-819 -368)",
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(819 368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H281.621V281.621H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 212.147,
    height: 118.449,
    transform: "translate(34.932 45.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.684,2H24.468A23.537,23.537,0,0,0,1,25.468V166.279a23.537,23.537,0,0,0,23.468,23.468h82.14L83.14,224.95v11.734h93.874V224.95l-23.468-35.2h82.14a23.537,23.537,0,0,0,23.468-23.468V25.468A23.537,23.537,0,0,0,235.684,2Zm0,140.811H24.468V25.468H235.684Z",
    transform: "translate(10.734 21.468)",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(955.723 423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H100V100H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.657,30.174h-12.5V22.716c0-10.875-7.957-20.582-18.789-21.624A20.865,20.865,0,0,0,16.5,21.841v8.333H4V88.5H70.657Zm-33.328,37.5A8.333,8.333,0,1,1,45.66,59.34,8.357,8.357,0,0,1,37.328,67.673Zm-12.5-37.5V21.841a12.5,12.5,0,1,1,25,0v8.333Z",
    transform: "translate(12.672 3.159)",
    fill: "#FF1E54"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(864.277 423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H100V100H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.684,2A41.684,41.684,0,1,0,85.368,43.684,41.7,41.7,0,0,0,43.684,2Zm0,12.505A12.505,12.505,0,1,1,31.179,27.01,12.488,12.488,0,0,1,43.684,14.505Zm0,59.191a30.015,30.015,0,0,1-25.01-13.422c.125-8.3,16.674-12.839,25.01-12.839,8.3,0,24.885,4.544,25.01,12.839A30.015,30.015,0,0,1,43.684,73.7Z",
    transform: "translate(6.316 6.316)",
    fill: "#3758fb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIntelligence403Icon);
export default __webpack_public_path__ + "static/media/TimeIntelligence_403_Icon.d698871789106887b276870f8bc5d911.svg";
export { ForwardRef as ReactComponent };